<template>
  <div class="expandable-image" :class="{ expanded }" @click="expanded = true"><i v-if="expanded" class="close-button">
      <svg style="width:24px;height:24px" viewBox="0 0 24 24">
        <path fill="#666666" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
      </svg>
    </i> <i v-if="!expanded" class="expand-button">
      <svg style="width:24px;height:24px" viewBox="0 0 24 24">
        <path fill="#000000" d="M10,21V19H6.41L10.91,14.5L9.5,13.09L5,17.59V14H3V21H10M14.5,10.91L19,6.41V10H21V3H14V5H17.59L13.09,9.5L14.5,10.91Z" />
      </svg>
    </i> <img v-bind="imgAttrs"></div>
</template>

<script setup>
// Replaces vue-expandable-image 0.1.0 (Vue 2 only) with the same markup, behaviour and styles
// (reference: node_modules/vue-expandable-image/src/ExpandableImage.vue). Only what the app uses: no
// closeOnBackgroundClick. As with the plugin, the attributes (alt, src, class) also stay on the outer element;
// the image gets them without class and style. The spaces between the elements are the original's.
import { computed, getCurrentInstance, nextTick, ref, useAttrs, watch } from "vue"

defineOptions({
  name: 'ExpandableImage',
})

const attrs = useAttrs()
const imgAttrs = computed(() => {
  // eslint-disable-next-line no-unused-vars
  const { class: cls, style, ...rest } = attrs
  return rest
})

const instance = getCurrentInstance()
const expanded = ref(false)

// a static copy of the element, shown full screen over the page
let cloned = null
let closeButton = null

const closeImage = (event) => {
  expanded.value = false
  event.stopPropagation()
}

const freezeVp = (e) => {
  e.preventDefault()
}

watch(expanded, (status) => {
  nextTick(() => {
    if (status) {
      cloned = instance.proxy.$el.cloneNode(true)
      closeButton = cloned.querySelector('.close-button')
      closeButton.addEventListener('click', closeImage)
      document.body.appendChild(cloned)
      document.body.style.overflow = 'hidden'
      cloned.addEventListener('touchmove', freezeVp, false)
      setTimeout(() => {
        cloned.style.opacity = 1
      }, 0)
    } else {
      cloned.style.opacity = 0
      cloned.removeEventListener('touchmove', freezeVp, false)
      setTimeout(() => {
        closeButton.removeEventListener('click', closeImage)
        cloned.remove()
        cloned = null
        closeButton = null
        document.body.style.overflow = 'auto'
      }, 250)
    }
  })
})
</script>

<style>
.expandable-image {
  position: relative;
  transition: 0.25s opacity;
  cursor: zoom-in;
}

body > .expandable-image.expanded {
  position: fixed;
  z-index: 999999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: black;
  display: flex;
  align-items: center;
  opacity: 0;
  padding-bottom: 0 !important;
  cursor: default;
}

body > .expandable-image.expanded > img {
  width: 100%;
  max-width: 1200px;
  max-height: 100%;
  object-fit: contain;
  margin: 0 auto;
}

body > .expandable-image.expanded > .close-button {
  display: block;
}

.close-button {
  position: fixed;
  top: 10px;
  right: 10px;
  display: none;
  cursor: pointer;
}
.expand-button svg,
.close-button svg {
  filter: drop-shadow(1px 1px 1px rgba(0,0,0,0.5));
}
.expand-button svg path,
.close-button svg path {
  fill: #FFF;
}
.expand-button {
  position: absolute;
  z-index: 999;
  right: 10px;
  top: 10px;
  padding: 0px;
  align-items: center;
  justify-content: center;
  padding: 3px;
  opacity: 0;
  transition: 0.2s opacity;
}

.expandable-image:hover .expand-button {
  opacity: 1;
}
.expand-button svg {
  width: 20px;
  height: 20px;
}
.expand-button path {
  fill: #FFF;
}

.expandable-image img {
  width: 100%;
}
</style>
